import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext.jsx';
import Login from './pages/Login.jsx';
import Setup from './pages/Setup.jsx';
import AccountSetup from './pages/AccountSetup.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Devices from './pages/Devices.jsx';
import Etechlog from './pages/Etechlog.jsx';
import CrossCheck from './pages/CrossCheck.jsx';
import Settings from './pages/Settings.jsx';
import Users from './pages/Users.jsx';
import Stats from './pages/Stats.jsx';
import Profile from './pages/Profile.jsx';
import Bookings from './pages/Bookings.jsx';
import Calendar from './pages/Calendar.jsx';
import Layout from './components/Layout.jsx';

function CenteredSpinner() {
  return (
    <div className="flex h-screen items-center justify-center text-cathay-700">Loading…</div>
  );
}

function RequireAuth({ children, adminOnly }) {
  const { user, loading, setupRequired } = useAuth();
  if (loading) return <CenteredSpinner />;
  if (setupRequired) return <Navigate to="/setup" replace />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  const { setupRequired, user, loading } = useAuth();
  if (loading) return <CenteredSpinner />;
  return (
    <Routes>
      <Route path="/setup-account" element={<AccountSetup />} />
      <Route
        path="/setup"
        element={setupRequired ? <Setup /> : <Navigate to={user ? '/' : '/login'} replace />}
      />
      <Route
        path="/login"
        element={
          setupRequired ? <Navigate to="/setup" replace />
          : user ? <Navigate to="/" replace />
          : <Login />
        }
      />
      <Route path="/" element={<RequireAuth><Dashboard /></RequireAuth>} />
      <Route path="/calendar" element={<RequireAuth><Calendar /></RequireAuth>} />
      <Route path="/bookings" element={<RequireAuth><Bookings /></RequireAuth>} />
      <Route path="/cross-check" element={<RequireAuth><CrossCheck /></RequireAuth>} />
      <Route path="/devices" element={<RequireAuth><Devices /></RequireAuth>} />
      <Route path="/etechlog" element={<RequireAuth><Etechlog /></RequireAuth>} />
      <Route path="/users" element={<RequireAuth><Users /></RequireAuth>} />
      <Route path="/stats" element={<RequireAuth><Stats /></RequireAuth>} />
      <Route path="/settings" element={<RequireAuth><Settings /></RequireAuth>} />
      <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
